export default __webpack_public_path__ + "static/media/error_network.38c1b91a.svg";